import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import TextLink from 'components/text_link/text_link'
import WheelLoading from 'components/loading/wheel_loading'

import styles from './uploading_overlay.scss'

class UploadingOverlay extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<main styleName='content'>
					{ this.props.message &&
						this.props.message.map((line, index) => <p key={index} styleName='message-line'>{line}</p>)
					}
					<div styleName='animation'>
						<WheelLoading />
					</div>
					<div styleName='button'>
						<TextLink
							onClick={this.props.buttonHandler}
							color='white'
							isUnderlined>
							{this.props.buttonLabel}
						</TextLink>
					</div>
				</main>
			</div>
		)
	}
}

UploadingOverlay.propTypes = {
	message: PropTypes.array,
	buttonLabel: PropTypes.string.isRequired,
	buttonHandler: PropTypes.func.isRequired,
}

export default CSSModules(UploadingOverlay, styles, { allowMultiple: true })
